import { ItemComponent } from '@seiue/ui'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { PaperBlock } from 'packages/sdks-next/growp'

import { BlockWrapper } from '../../BlockWrapper'

import { MaterialBlock } from './Block'
import { MaterialSelectedFooter } from './MaterialSelectedFooter'

/**
 * 资料 footer 块
 *
 * @param param - Argument Object
 * @param param.blockData - 块数据
 * @param param.dragSource - 拖拽源
 * @constructor
 */
export const BlockMaterial: ItemComponent<{ blockData: PaperBlock }> = ({
  blockData,
  dragSource,
}) => (
  <BlockWrapper
    dragSource={dragSource}
    blockData={blockData}
    block={MaterialBlock}
    footers={[
      {
        visible: (f) => f.state === BlockStateEnum.Selected,
        render: MaterialSelectedFooter,
      },
    ]}
  />
)
